import {Component, computed, inject, resource, ResourceRef, signal, Signal} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {GenericApiService} from "../../../shared/api/generic-api.service";
import {Router, RouterLink, RouterOutlet} from "@angular/router";
import { v4 as uuid } from 'uuid';
import {TranslatePipe} from "@ngx-translate/core";
import {LoaderElementComponent} from "../../../shared/loader-element/loader-element.component";
@Component({
  selector: 'app-product-listing',
  imports: [
    FormsModule,
    RouterOutlet,
    RouterLink,
    TranslatePipe,
    LoaderElementComponent
  ],
  templateUrl: './product-listing.component.html',
  styleUrl: './product-listing.component.scss',
  standalone: true
})
export class ProductListingComponent {
  private http = inject(GenericApiService);
  private router = inject(Router);

  //handles visibility of product list
  protected subRouteActive = signal(false);

  protected productChange = signal(uuid());

  protected criteria = computed(() => ({
    subRoute:this.subRouteActive(),
    action: this.productChange()
  }))

  protected products: ResourceRef<any> = resource({
    request: this.criteria,
    loader: () => new Promise((resolve) => this.http.get('/api/product').subscribe(resolve)),
  })

  //user filter input
  protected searchStr: Signal<string> = signal("");

  //output to ui of products
  protected filteredProducts: Signal<any> = computed(() =>
      this.products.value()?.filter((product: any) => this.searchStr() === '' || product.name?.includes(this.searchStr()))
  );

  //listens routeroutlet for route changes and toggles visibility of product list
  onRouteChange(value: boolean) { this.subRouteActive.set(value); }

  onRemoveProduct(id: number) {
    if(confirm("Are you sure you want to delete product?")){
      this.http.delete(`/api/product/${id}`).subscribe(() => {
        this.productChange.set(uuid());
      });
    }
  }

}
